import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { GtmService } from '@df/module-gtm/gtm.service';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NModuleGtm } from './df-module-gtm.config';

export const providers = (config?: DeepPartial<NModuleGtm.IModuleOptions>) => [
    {
        provide: NModuleGtm.OPTIONS,
        useFactory: () => {
            return defaultsDeep(config || {}, <NModuleGtm.IModuleOptions>{
                customerFields: ['logged', 'id', 'mage_store', 'group_id', 'email', 'newsletter']
            });
        }
    }
];

export function provideDfModuleGtm(config?: DeepPartial<NModuleGtm.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        ...providers(config),
        {
            provide: APP_INITIALIZER,
            useFactory: (gtmService: GtmService) => () => {
                gtmService.appInitialize();
            },
            deps: [GtmService],
            multi: true
        }
    ]);
}
